export const initHomeVideo = () => {
    const path = '/build/assets/videos';
    const videoEl = `<source src="${ path }/home-page-video-2.mp4" type="video/mp4">`;

    initGreetingVideo(videoEl, 40000, 6000);
}

/**
 *
 */
export const initTechSummitVideo = () => {
    const path = '/build/assets/images/landings/tech-summit-2';
    const videoEl = `<source src="${ path }/IT-Creations-Annual-Tech_1080p-muted.mp4" type="video/mp4">`;
    const videoTime = 39000;
    const onScroll = () => {
        window.removeEventListener('scroll', onScroll);
        initGreetingVideo(videoEl, videoTime, 2000);
    };
    if (window.innerWidth >= 1024 && window.innerHeight < 1366) {
        window.addEventListener('scroll', onScroll);
    }
}


/**
 *
 */
const initGreetingVideo = (videoEl, playTime, loadingDelay) => {
    const videoGreeting = document.getElementById('video-greeting');
    const progressBar = document.querySelector('.progress-bar');
    const mainWrp = document.querySelector('.main-wrp');
    let countdown = (+videoGreeting.getAttribute('data-countdown') || 0) + (loadingDelay / 2);

    if (!videoGreeting || !progressBar || !mainWrp) {
        return
    }

    const startPlayVideo = () => {
        progressBar.classList.remove('progress-bar-active');
        videoGreeting.parentElement.classList.add('parallax-overlay-black');
        videoGreeting.style.opacity = '1';
        videoGreeting.play();
        videoGreeting.removeEventListener('canplaythrough', startPlayVideo);
        setTimeout(removeVideo, playTime);
    }

    greetingVideo();


    function greetingVideo() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        const isEdge = !!window.StyleMedia;

        if (isFirefox || isEdge) {
            countdown = 15000;
        }

        mainWrp.style.visibility = 'visible';

        if (window.innerWidth >= 1024 && window.innerHeight < 1366) {
            videoGreeting.addEventListener('canplaythrough', startPlayVideo);

            const injectVideo = () => {
                videoGreeting.innerHTML = videoEl;
                videoGreeting.load();
            };

            const scheduleInject = () => {
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(injectVideo, { timeout: loadingDelay });
                } else {
                    setTimeout(injectVideo, 1000);
                }
            };

            if (document.readyState === 'complete') {
                scheduleInject();
            } else {
                window.addEventListener('load', scheduleInject, { once: true });
            }

            progressBar.classList.add('progress-bar-active');
            progressBar.style.animationDuration = countdown + 'ms';
        } else {
            videoGreeting.remove();
            progressBar.remove();
        }
    }

    function removeVideo() {
        videoGreeting.pause();
        progressBar.remove();
        videoGreeting.remove();
    }
}
